const onPressEnter = (onPressHandler) => ({ key }) => {
  if (key === 'Enter') {
    onPressHandler();
  }
};

export default onPressEnter;
